import script from "./ExperienceEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./ExperienceEditor.vue?vue&type=script&setup=true&lang=js"

import "./ExperienceEditor.vue?vue&type=style&index=0&id=37de20ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37de20ce"]])

export default __exports__